module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-circle-fill-2f3133fe.svg";